module.exports = __webpack_public_path__ + "img/l2g-img.3f62cc19.png";